import axios from "axios";
import { zoop } from "../utils/ZoopConfig";
import { getToken } from "./Auth";

export const Api = axios.create({
  baseURL: "https://api.paguedireto.com.br",
  // baseURL: "https://tst-api.paguedireto.com.br",
  // baseURL: "http://192.168.10.100:9104",
  // baseURL: "http://localhost:9134",
  // baseURL: "https://d801-2804-d4b-8902-300-3d23-e337-ad8b-460a.sa.ngrok.io/",
  timeout: 50000,
});

export const ApiAdimplencia = axios.create({
  baseURL: "https://api-recorrencia.paguedireto.com.br",
  // baseURL: "https://tst-api-recorrencia.paguedireto.com.br",
  // baseURL: "http://localhost:9007",
  timeout: 50000,
});

Api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

ApiAdimplencia.interceptors.request.use(async (config) => {
  const token = getToken();
  //console.log(token)
  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
});

export const ApiZoop = axios.create({
  baseURL: "https://api.zoop.ws",
  timeout: 50000,
});

ApiZoop.interceptors.request.use(async (config) => {
  const token = zoop.ZOOP_TOKEN;
  if (token) {
    config.headers.Authorization = `Basic ${token}`;
  }
  return config;
});
